import { Module } from 'vuex'

import { RootState } from '@/store/types'

import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { DefinitionsState } from './types'

const definitionsModule: Module<DefinitionsState, RootState> = {
  namespaced: true,
  actions,
  mutations,
  getters,
  state: {
    genders: new Map([
      ['female', 'F'],
      ['male', 'M'],
      ['both', 'B'],
    ]),
    services: [],
    rejectReasons: [],
    carePlans: [],
    insuranceCompanies: [],
  },
}

export default definitionsModule
